import React from "react";
import ReactDOMServer from "react-dom/server";
import {
  EmptyNote,
  InfoTable,
  SectionTitle,
  formatDate,
  maskEmail,
  maskPassport,
  maskPhone,
} from "./BnplFreezePDFUtils";

export default function BnplFreezePDFPassengersStatic({ flight }) {
  const travelers = flight?.travelers || [];

  const content = (
    <table className="w-full mb-2" cellPadding="0" cellSpacing="0">
      <tbody>
        <tr>
          <td>
            <SectionTitle>4. Passengers</SectionTitle>

            {travelers.length ? (
              <table
                className="w-full mb-4 text-xs border border-gray-200"
                cellPadding="0"
                cellSpacing="0"
              >
                <thead>
                  <tr className="bg-gray-800 text-white">
                    <th className="px-2 py-2 text-left font-semibold">#</th>
                    <th className="px-2 py-2 text-left font-semibold">
                      Passenger
                    </th>
                    <th className="px-2 py-2 text-left font-semibold">Type</th>
                    <th className="px-2 py-2 text-left font-semibold">
                      Document
                    </th>
                    <th className="px-2 py-2 text-left font-semibold">
                      Contact
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {travelers.map((traveler, index) => {
                    const fullName =
                      [
                        traveler?.title,
                        traveler?.firstName,
                        traveler?.middleName,
                        traveler?.lastName,
                      ]
                        .filter(Boolean)
                        .join(" ") || "-";

                    return (
                      <tr
                        key={traveler?._id || traveler?.id || index}
                        className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                      >
                        <td className="px-2 py-2 border-b border-gray-200 align-top font-bold text-gray-800">
                          {index + 1}
                        </td>
                        <td className="px-2 py-2 border-b border-gray-200 align-top">
                          <div className="font-bold text-gray-800">
                            {fullName}
                          </div>
                          <div className="text-gray-500 mt-1">
                            DOB: {formatDate(traveler?.birthDate)}
                          </div>
                          <div className="text-gray-500">
                            Gender: {traveler?.gender || "-"}
                          </div>
                        </td>
                        <td className="px-2 py-2 border-b border-gray-200 align-top font-semibold text-gray-800">
                          {traveler?.travelerType || "-"}
                        </td>
                        <td className="px-2 py-2 border-b border-gray-200 align-top text-gray-700">
                          <div>
                            Nationality:{" "}
                            {traveler?.document?.nationality || "-"}
                          </div>
                          <div>
                            Passport: {maskPassport(traveler?.document?.number)}
                          </div>
                        </td>
                        <td className="px-2 py-2 border-b border-gray-200 align-top text-gray-700">
                          <div>{maskEmail(traveler?.email)}</div>
                          <div className="mt-1">
                            {maskPhone(traveler?.phone)}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <EmptyNote>No passengers found.</EmptyNote>
            )}

            <SectionTitle>5. Ticket Information</SectionTitle>
            <InfoTable
              rows={[
                { label: "Ticket Status", value: flight?.status },
                {
                  label: "Ticket Number",
                  value: travelers?.[0]?.ticketNumbers?.[0],
                },
                { label: "Airline PNR", value: flight?.pnr },
                { label: "Booking ID", value: flight?.bookingId },
                {
                  label: "Void Deadline",
                  value: formatDate(flight?.voidDeadline),
                },
              ]}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );

  return ReactDOMServer.renderToStaticMarkup(content);
}
